import React from 'react';
import DashboardButton from '../common/DashboardButton';
import SectionHeader from '../common/SectionHeader';
import Card from '../common/Card';
import mylabsPlusLogo from '../../assets/dashboard/mylabs_plus_logo.png';

interface MyLabsPlusCardProps {
    isSubscribed?: boolean;
}

const MyLabsPlusCard: React.FC<MyLabsPlusCardProps> = ({isSubscribed = false}) => {
    return (
        <section className={`space-y-6 ${isSubscribed ? 'hidden' : ''}`}>
            <SectionHeader title="My Labs Plus" />
            <Card variant="elevated" padding="none" rounded="3xl" className="overflow-hidden">
                <div className="bg-gradient-to-br from-mld-primary-100 to-cyan-100 p-8">
                    <div className="text-center">
                        <h4 className="text-lg font-medium text-mld-text-primary mb-4 md:text-base">
                            Join Plus and Achieve
                            <br />
                            Your Health Goals
                        </h4>
                        <img src={mylabsPlusLogo} alt="My Labs Plus" className="mx-auto my-6 h-20" />
                    </div>
                </div>
                <div className="bg-white p-8 text-center space-y-4">
                    <p className="text-base text-mld-text-primary leading-relaxed">
                        Advanced health metrics, lab insights, wellness coaching, discounts, and more
                    </p>
                    <p className="text-2xl font-semibold text-mld-text-primary md:text-xl">$49.00/mo</p>
                    <DashboardButton text="Explore Benefits" />
                </div>
            </Card>
        </section>
    );
};

export default MyLabsPlusCard;
